import { validate } from 'revalidator';
import { allowedPrefContactMethods, phoneIsValid } from '../../lib/validator-helpers';

export default function validateContact (form) {
	return validate(form, {
		type: 'object',
		properties: {
			phone: {
				type: 'string',
				required: true,
				allowEmpty: false,
				conform: phone => !phone || phoneIsValid(phone),
				messages: {
					allowEmpty: 'fieldIsRequired',
					conform: 'enterValidPhone'
				}
			},
			phoneType: {
				type: 'string',
				required: true,
				allowEmpty: false,
				enum: ['mobile', 'home', 'work', 'other']
			},
			email: {
				type: 'string',
				required: true,
				allowEmpty: false,
				format: 'email',
				messages: {
					allowEmpty: 'fieldIsRequired',
					format: 'enterValidEmail'
				}
			},
			prefContactMethod: {
				type: 'string',
				// TODO: Re-enable preferred contact method later
				required: false,
				allowEmpty: false,
				enum: allowedPrefContactMethods(false, form.phoneType),
				messages: {
					allowEmpty: 'selectPrefContactMethod',
					enum: 'selectPrefContactMethod'
				}
			}
		}
	});
}
